export default __webpack_public_path__ + "static/media/king.5296db45.gif";